import { HTTPService } from './HTTPService'

export const AppHTTPService = new HTTPService()
export const api = AppHTTPService.client
